const NotFound = props => {
  return(
    <h2>NotFound</h2>
  );
}
export default NotFound;